import { render, staticRenderFns } from "./orderNewRevise.vue?vue&type=template&id=31c13b93&scoped=true&"
import script from "./orderNewRevise.vue?vue&type=script&lang=js&"
export * from "./orderNewRevise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c13b93",
  null
  
)

export default component.exports